/* ==========================================================================
   Paola & Joy — recently viewed.
   Keeps a short list of product handles in this browser only, then rebuilds
   the row from Shopify's own product JSON. Nothing is sent anywhere.
   ========================================================================== */
(function () {
  var KEY = 'pj:recently-viewed';
  var MAX_STORED = 20;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }

  function money(cents, format) {
    var value = cents / 100;
    function withCommas(n, dp) {
      var parts = n.toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return (format || '${{amount}}')
      .replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
        switch (name) {
          case 'amount_no_decimals': return withCommas(value, 0);
          case 'amount_with_comma_separator': return withCommas(value, 2).replace(/,/g, ' ').replace('.', ',');
          case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, ' ');
          default: return withCommas(value, 2);
        }
      })
      .replace(/<[^>]*>/g, '');
  }

  function sized(src, w) {
    if (!src) return '';
    return src.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }

  function esc(v) { return String(v == null ? '' : v).replace(/"/g, '&quot;'); }

  function tile(product, fmt) {
    /* A div, not an anchor: the quick-add control is a <button>, and a button
       inside an anchor is invalid and unclickable. Same arrangement as the
       collection tile — one link stretched over the whole card, with the add
       button sitting above it in the stacking order. */
    var el = document.createElement('div');
    el.className = 'pj-rv__tile';

    var onSale = product.compare_at_price > product.price;
    var img = product.featured_image
      ? '<img src="' + sized(product.featured_image, 700) + '" alt="' + esc(product.title) + '" loading="lazy">'
      : '';

    /* Only single-variant pieces can be added without a choice being made;
       anything else sends the shopper to the product page, which is what the
       shared quick-add handler does with data-single="false". */
    var variants = product.variants || [];
    var single = variants.length === 1;
    var first = variants[0] || {};
    var add = '';
    if (product.available) {
      add =
        '<button class="pj-rv__add" type="button" data-pj-quickadd' +
        ' data-variant="' + esc(first.id) + '"' +
        ' data-single="' + single + '"' +
        ' data-url="' + esc(product.url) + '"' +
        ' data-title="' + esc(product.title) + '"' +
        ' aria-label="' + (single ? 'Add ' : 'Choose options for ') + esc(product.title) + '">' +
        '<span class="pj-rv__add-plus" aria-hidden="true">+</span>' +
        '</button>';
    }

    el.innerHTML =
      '<a class="pj-rv__link" href="' + esc(product.url) + '"><span class="pj-sr">' + esc(product.title) + '</span></a>' +
      '<span class="pj-media pj-rv__media">' + img + add + '</span>' +
      '<span class="pj-rv__row">' +
        '<span class="pj-rv__name">' + product.title + '</span>' +
        '<span class="pj-rv__price' + (onSale ? ' pj-rv__price--sale' : '') + '">' +
          (onSale ? '<s>' + money(product.compare_at_price, fmt) + '</s> ' : '') +
          money(product.price, fmt) +
        '</span>' +
      '</span>';
    return el;
  }

  function init(root) {
    if (root.dataset.pjRvReady === 'true') return;
    root.dataset.pjRvReady = 'true';

    /* The handle is recorded globally in theme.liquid on every product page,
       so this section only reads the list. */
    var current = root.dataset.currentHandle || '';

    var limit = parseInt(root.dataset.limit, 10) || 3;
    var fmt = root.dataset.moneyFormat;
    var grid = root.querySelector('[data-pj-rv-grid]');
    if (!grid) return;

    var handles = read().filter(function (h) { return h && h !== current; }).slice(0, limit);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetch(window.Shopify.routes.root + 'products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var found = products.filter(Boolean);
      if (!found.length) return;
      found.forEach(function (p) { grid.appendChild(tile(p, fmt)); });
      root.hidden = false;
      /* These tiles are built after pj-collection.js has booted, so wire the
         add buttons that were just created. */
      if (window.PJQuickAdd) window.PJQuickAdd.boot();
    });
  }

  function boot() { document.querySelectorAll('[data-pj-recently-viewed]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
